import keyBy from 'lodash/keyBy';

export const INVITATION_STATUSES = [
  { code: 'pending', name: 'Pending' },
  { code: 'accepted', name: 'Accepted' },
];

export const INVITATION_MAP = keyBy(INVITATION_STATUSES, 'code');
